import type { EventType } from '../types';

const ALL_EVENT_TYPES: EventType[] = ['click', 'loaded', 'visible'];

export default ALL_EVENT_TYPES;
